export var SHOP_PREVIEW_OVERRIDE_KEY = "X-IF-OVERRIDE-BRAND-PREVIEW-LOCALE";
